






































































































import { JwtClaims } from "@/store/modules/auth";
import {
  ContingentDateSpans,
  ContingentDataFormat,
  ContingentSettings,
} from "@/store/modules/contingent"
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { RatePlan } from "@/components/calendar/CalendarTypes";
import { GlobalFilterProperty } from "@/store/modules/globalFilters";

@Component
export default class ContingentSettingsForm extends Vue {
  @Getter("contingent/isLoading") loading?: boolean;
  @Getter("contingent/settings") settingsList?: ContingentSettings[];
  @Getter("auth/claims") claims?: JwtClaims;
  @Action("contingent/updateSettings") updateSettings?: (
    payload?: ContingentSettings
  ) => void;
  @Getter("calendar/nonOBRatePlans") nonOBRatePlans?: RatePlan[];
  @Action("calendar/refreshNonOBRatePlans") refreshNonOBRatePlans?: () => Promise<void>;
  @Getter("globalFilters/filteredProperties") properties?: GlobalFilterProperty[];


  async created () {
    if ((this.nonOBRatePlans?.length ?? 0) === 0 && this.refreshNonOBRatePlans) {
      await this.refreshNonOBRatePlans();
    }
    this.refreshSelectedRatePlan();
  }

  update(payload: Partial<ContingentSettings>) {
    this.currentSettings &&
      this.updateSettings &&
      this.updateSettings({ ...this.currentSettings, ...payload, userId: this.currentUserId, tenantId: this.currentTenantId });
  }

  get currentTenantId() {
    return this.claims ? +this.claims.tid : 0;
  }

  get currentUserId() {
    return this.claims ? +this.claims.sid : 0;
  }

  get currentSettings() {
    const settings = this.settingsList?.find(x => x.userId == this.currentUserId && x.tenantId == this.currentTenantId);
    if(settings)
    {
      return settings;
    }
    return this.settingsList?.find(x => x.userId == 0);
  }

  possibleDateSpans: { key: ContingentDateSpans; text: string }[] = [
    { key: "week", text: "Contingent.DateSpans.Week" },
    { key: "month", text: "Contingent.DateSpans.Month" },
    { key: "year", text: "Contingent.DateSpans.Year" },
  ];
  get dateSpan(): ContingentDateSpans {
    return this.currentSettings?.dateSpan ?? "month";
  }
  set dateSpan(value: ContingentDateSpans) {
    this.currentSettings &&
      this.updateSettings &&
      this.updateSettings({ ...this.currentSettings, dateSpan: value });
  }

  dataFormatOptions: { key: ContingentDataFormat; text: string }[] = [
    { key: "percentage", text: "Contingent.DataFormat.Percentage" },
    { key: "number", text: "Contingent.DataFormat.Number" },
  ];
  get dataFormat(): ContingentDataFormat {
    return this.currentSettings?.dataFormat ?? "percentage";
  }
  set dataFormat(value: ContingentDataFormat) {
    this.update({ dataFormat: value });
  }

  get showPrice() {
    return this.currentSettings?.showPrice ?? false;
  }
  set showPrice(value: boolean) {
    this.update({ showPrice: value });
  }

  get showPriceDifference() {
    return this.currentSettings?.showPriceDifference ?? false;
  }
  set showPriceDifference(value: boolean) {
    this.update({ showPriceDifference: value });
  }

  get selectedProperty() {
    return this.currentSettings?.selectedPropertyId == undefined || this.currentSettings?.selectedPropertyId == 0
      ? this.properties?.find(x => x.status)?.propertyId ?? this.properties?.find(x => !x.status)?.propertyId ?? 0
      : this.currentSettings?.selectedPropertyId;
  }
  set selectedProperty(value: number) {
    if(this.currentSettings) {
      this.update({ selectedPropertyId: value });
    }
  }

  get nonDerivedRatePlans() {
    return this.nonOBRatePlans?.filter((x) => !x.isDerived) ?? [];
  }

  selectedRatePlan: number | null = null;

  refreshSelectedRatePlan() {
    const selectedRatePlan = this.currentSettings?.selectedRatePlanId ?? null;
    if(selectedRatePlan) {
      this.selectedRatePlan = selectedRatePlan;
    } else {
      this.selectedRatePlan = null
    }
  }

  updateListRatePlanSettings() {
    this.update({selectedRatePlanId: this.selectedRatePlan ?? null});
  }
}
